/** Product Configuration Chooser — nested tabs, without a carousel dependency. */
(function () {
    /* =========================================================
       Initialise one chooser
       Each instance owns its selection and event handlers.
       ========================================================= */
    function initChooser(root) {
        if (root.dataset.chooserInitialized === 'true') return;
        const bandTabs = Array.from(root.querySelectorAll('[data-band-tab]'));
        const bandPanels = Array.from(root.querySelectorAll('[data-band-panel]'));
        if (!bandTabs.length || !bandPanels.length) return;
        let selectedModel = null;

        /* =====================================================
           Shared tab behavior
           Automatic activation on Arrow/Home/End; native buttons
           also support Enter and Space. Keep focus on the control.
           ===================================================== */
        function connectTabs(tabs, activate) {
            tabs.forEach((tab, index) => {
                tab.addEventListener('click', () => activate(tab));
                tab.addEventListener('keydown', (event) => {
                    let target;
                    if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
                    else if (event.key === 'ArrowLeft') target = (index - 1 + tabs.length) % tabs.length;
                    else if (event.key === 'Home') target = 0;
                    else if (event.key === 'End') target = tabs.length - 1;
                    else return;
                    event.preventDefault();
                    activate(tabs[target]);
                    tabs[target].focus();
                });
            });
        }
        function setSelected(tab, active) {
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.tabIndex = active ? 0 : -1;
        }

        /* =====================================================
           Model selection
           Retain this model when the next band also contains it.
           ===================================================== */
        function selectModel(panel, modelKey) {
            const tabs = Array.from(panel.querySelectorAll('[data-model-tab]'));
            const selected = tabs.find(tab => tab.dataset.modelTab === modelKey) || tabs[0];
            if (!selected) return;
            selectedModel = selected.dataset.modelTab;
            tabs.forEach(tab => setSelected(tab, tab === selected));
            panel.querySelectorAll('[data-model-panel]').forEach(modelPanel => {
                modelPanel.hidden = modelPanel.dataset.modelPanel !== selectedModel;
            });
        }

        /* =====================================================
           Band selection
           Use the first available model if the previous selection
           does not exist in the new band. Never move focus into a
           panel automatically.
           ===================================================== */
        function selectBand(tab) {
            bandTabs.forEach(item => setSelected(item, item === tab));
            bandPanels.forEach(panel => {
                const active = panel.dataset.bandPanel === tab.dataset.bandTab;
                panel.hidden = !active;
                if (active) selectModel(panel, selectedModel);
            });
        }
        bandPanels.forEach(panel => {
            const tabs = Array.from(panel.querySelectorAll('[data-model-tab]'));
            connectTabs(tabs, tab => selectModel(panel, tab.dataset.modelTab));
            const navigation = panel.querySelector('[data-model-navigation]');
            if (navigation) navigation.hidden = false;
        });
        connectTabs(bandTabs, selectBand);
        selectBand(bandTabs[0]);
        root.querySelector('[data-band-navigation]').hidden = false;
        root.classList.add('is-enhanced');
        root.dataset.chooserInitialized = 'true';
    }

    /* =========================================================
       Frontend only
       Static editor previews show all configurations by band.
       ========================================================= */
    function initAll() {
        document.querySelectorAll('[data-configuration-chooser]').forEach(initChooser);
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
    } else {
        initAll();
    }
})();
